import '.ae{flex:1 1 0;}.ssr-plugin'
import '.af{min-width:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import LandingContentImageColumn from './LandingContentImageColumn'
import LandingContentTitle from './LandingContentTitle'
import Column from '@app/components/layout/Column'
import { LandingContentDescription } from './LandingContentDescription'
import { useRef } from 'react'
import { Button } from '@app/components/core/button/Button'
import useLockedVerticalCenterPadding from '@app/util/hooks/useLockedVerticalCenterPadding'
import { useTranslations } from '@i18n/useLanguage'

export type LandingContentProps = {
  imageSide?: 'left' | 'right'
  title: string
  subtitle?: string
  description: string
  badge: string
  style?: Style
  imageSrc?: string
  isCard?: boolean
  planDemoButton?: boolean
}

const LandingContent = ({
  imageSide = 'left',
  title,
  subtitle,
  description,
  badge,
  style,
  imageSrc,
  isCard = false,
  planDemoButton = false,
}: LandingContentProps) => {
  const isMobile = useMediaQuery()
  const t = useTranslations()
  const containerRef = useRef<HTMLDivElement>(null)
  const imageColumnRef = useRef<HTMLDivElement>(null)
  const textColumnWrapperRef = useRef<HTMLDivElement>(null)
  const lockedPaddingTop = useLockedVerticalCenterPadding({
    isMobile,
    containerRef,
    anchorRef: imageColumnRef,
    contentRef: textColumnWrapperRef,
  })

  const rowAlignItems = isMobile
    ? 'stretch'
    : lockedPaddingTop !== null
      ? 'flex-start'
      : 'center'

  const textColumn = (
    <styled.div className="ae af"
      ref={textColumnWrapperRef}
      style={{
        ...(lockedPaddingTop !== null ? { paddingTop: lockedPaddingTop } : {}),
      }}
    >
      <Column style={{ gap: '2rem' }}>
        <LandingContentTitle
          badge={badge}
          title={title}
          subtitle={subtitle}
          isCard={isCard}
        />
        <LandingContentDescription description={description} />
        {planDemoButton && (
          <Button
            label={t.app.forMunicipalities.planDemoButton}
            to="https://meetings-eu1.hubspot.com/sascha-glasl"
          />
        )}
      </Column>
    </styled.div>
  )

  const rowDirection = isMobile
    ? 'column'
    : imageSide === 'left'
      ? 'row'
      : 'row-reverse'

  return (
    <styled.div className="a"
      ref={containerRef}
      style={{
        flexDirection: rowDirection,
        alignItems: rowAlignItems,
        gap: isMobile ? '2rem' : '6rem',
        margin: isCard ? (isMobile ? '0.5rem' : '4.5rem') : 0,
        ...style,
      }}
    >
      <div className="a ae af"
        ref={imageColumnRef}
      >
        <LandingContentImageColumn imageSrc={imageSrc} imageAlt={title} />
      </div>
      {textColumn}
    </styled.div>
  )
}

export default LandingContent
